import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { styleMap } from 'lit/directives/style-map.js';
import { getBasePath } from '../../utilities/base-path.js';
import { ICON_TYPES } from './constants/IconConstants.js';
import { FONT_SIZES } from '../../internal/constants/styleConstants.js';
import styles from './arc-icon.styles.js';
export default class ArcIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.name = ICON_TYPES.fire;
        this.size = FONT_SIZES.medium;
        this.rotation = 0;
    }
    render() {
        const DEFAULT_PATH = `${getBasePath()}/assets/icons.svg`;
        const iconStyles = {
            transform: this.rotation ? `rotate(${this.rotation}deg)` : null,
            height: `var(--arc-font-size-${this.size})`,
            width: `var(--arc-font-size-${this.size})`,
        };
        return html `
      <svg
        id="main"
        style=${styleMap(iconStyles)}
        role=${ifDefined(this.label ? 'img' : undefined)}
        aria-label=${ifDefined(this.label || undefined)}
        aria-hidden=${ifDefined(this.label ? undefined : 'true')}
      >
        <use href="${DEFAULT_PATH}#arc-${this.name}" xlink:href="${DEFAULT_PATH}#arc-${this.name}" />
      </svg>
    `;
    }
}
ArcIcon.tag = 'arc-icon';
ArcIcon.styles = styles;
__decorate([
    property({ type: String, reflect: true })
], ArcIcon.prototype, "name", void 0);
__decorate([
    property({ type: String })
], ArcIcon.prototype, "label", void 0);
__decorate([
    property({ type: String, reflect: true })
], ArcIcon.prototype, "size", void 0);
__decorate([
    property({ type: Number })
], ArcIcon.prototype, "rotation", void 0);
